module.exports = __webpack_public_path__ + "img/streamingtab.76d2075c.svg";